module.exports = __webpack_public_path__ + "/login_ui/img/sa-6076fa7034c1e86685df212fe6b8c8b3.svg";